<script lang="ts" setup>
import { computed, ref, watch } from 'vue'
import { $getToken } from '@/helpers'
import { isInThirdAppBrowser } from '@/utils/bowserEnv'

const props = withDefaults(defineProps<{
  value: boolean
}>(), {
  value: false,
})
const emit = defineEmits<{
  (event: 'input', value: boolean): void
}>()

const show = ref(false)
const setToken = function () {
  const t = $getToken() || ''
  const url = new URL(window.location.href)

  if (isInThirdAppBrowser())
    url.searchParams.set('bt', t)

  history.replaceState({}, '', url.href)
}

const removeToken = function () {
  const url = new URL(window.location.href)
  if (url.searchParams.has('bt'))
    url.searchParams.delete('bt')

  history.replaceState({}, '', url.href)
}

watch(
  () => props.value,
  () => {
    show.value = props.value
  },
)
watch(
  () => show.value,
  (value) => {
    emit('input', value)

    if (value)
      setToken()

    if (!value)
      removeToken()
  },
)

const upArrowTop = computed(() => {
  return window.innerHeight / 2 - 110
})
</script>

<template>
  <BasicModal v-model="show">
    <div class="p-5 home-bg">
      <div class="text-16px font-medium text-center">
        <p>To enhance your reading experience, you can click the menu button in the upper right corner and select</p>
      </div>
      <div class="text-#9875FB font-bold text-center mt-2">
        <p>"Open in external browser."</p>
      </div>
    </div>

    <img src="@/assets/up-arrow.png" class="fixed w-48px left-80%" :style="{ top: `-${upArrowTop}px` }">
  </BasicModal>
</template>

<style lang="scss" scoped>
.home-bg {
  background: url('@/assets/home-bg.webp') no-repeat top left;
  background-size: 100% 100%;
  border-radius: 12px;
  overflow: hidden;
}
</style>
